import React from 'react'
import { Table, Input } from 'reactstrap'
import styled from 'styled-components'
import NumberFormat from 'react-number-format'
import get from 'lodash/get'
import shortid from 'shortid'
import TrashDefault from '../../../../static/images/trash-default.svg'
import TrashHover from '../../../../static/images/trash-hover.svg'
import { vendor_cost_table_header } from '../../constants'
import { FONTS } from '../../../../constants'

export default class VendorCostTable extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (JSON.stringify(nextProps) === JSON.stringify(this.props)) return false
    return true
  }

  filterVendor = (element) => {
    const search_vendor = get(this.props, 'search_vendor', '')
    if (search_vendor !== '' && element) {
      const vendor_name = element.vendor_name.toLowerCase()
      const description = element.description.toLowerCase()
      const sub_project_code = element.sub_project_code.toLowerCase()
      return vendor_name.includes(search_vendor.toLowerCase())
      || description.includes(search_vendor.toLowerCase())
      || sub_project_code.includes(search_vendor.toLowerCase())
    } return element
  }

  render() {
    const editVendor = get(this.props, 'editVendor')
    const projectByID = get(this.props, 'projectByID')
    const presale_snapshot = get(projectByID, 'presale_snapshot.snapshot')
    const rSelected = get(this.props, 'rSelected')
    const isPresale = presale_snapshot && rSelected === 1
    const vendors = !isPresale ? get(this.props, 'vendors', []) : presale_snapshot.vendors
    const handleChangeCost = get(this.props, 'handleChangeCost')
    const deleteVendor = get(this.props, 'deleteVendor')

    return (
      /* eslint no-underscore-dangle: 0 */
      <TableDiv>
        <NewTable bordered /* hover */>
          <Header>
            <tr style={{ fontFamily: 'Gotham' }}>
              { vendor_cost_table_header.map(v => {
                  return (
                    <th key={ shortid() }>{v.label}</th>
                  )
                })
              }
            </tr>
          </Header>
          <BodyTable>
            { vendors.filter(this.filterVendor).map((vendor, key) => {
                return (
                  <tr key={ shortid() }>
                    <td>
                      <InputField
                        id={key}
                        name='sub_project_code'
                        disabled={!editVendor}
                        defaultValue={vendor.sub_project_code}
                        onBlur={(e) => handleChangeCost(e)}
                      />
                    </td>
                    <td>
                      <InputField
                        id={key}
                        name='vendor_name'
                        disabled={!editVendor}
                        defaultValue={vendor.vendor_name}
                        onBlur={(e) => handleChangeCost(e)}
                      />
                    </td>
                    <td>
                      <InputField
                        id={key}
                        name='description'
                        disabled={!editVendor}
                        defaultValue={vendor.description}
                        onBlur={(e) => handleChangeCost(e)}
                      />
                    </td>
                    <td>
                      <NumberField
                        id={key}
                        name='cost'
                        disabled={!editVendor}
                        value={vendor.cost}
                        allowEmptyFormatting={ true }
                        thousandSeparator={ true }
                        decimalScale={ 2 }
                        fixedDecimalScale={ true }
                        onBlur={ (e) => {
                          // e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                          handleChangeCost(e) }  }
                      />
                    </td>
                    <td>
                      <NumberField
                        id={key}
                        name='price'
                        disabled={!editVendor}
                        value={vendor.price}
                        allowEmptyFormatting={ true }
                        thousandSeparator={ true }
                        decimalScale={ 2 }
                        fixedDecimalScale={ true }
                        onBlur={ (e) => {
                          // e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                          handleChangeCost(e) }  }
                      />
                    </td>
                    <td>
                      <NumberField
                        id={key}
                        name='man_days'
                        disabled={!editVendor}
                        value={vendor.man_days}
                        allowEmptyFormatting={ true }
                        thousandSeparator={ true }
                        decimalScale={ 2 }
                        fixedDecimalScale={ true }
                        onBlur={ (e) => {
                          // e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                          handleChangeCost(e) }  }
                      />
                    </td>
                    <td>
                      <Trash
                        onClick={
                          editVendor ?
                            () => deleteVendor(key)
                            : () => { }
                        }
                        edit={editVendor}
                      />
                    </td>
                  </tr>
                )
              })
            }
          </BodyTable>
        </NewTable>
      </TableDiv>
    )
  }
}

const NewTable = styled(Table)`
  background: white;
  margin-bottom: 10%;
  thead, tbody tr{
    display:table;
    width:100%;
    table-layout:fixed;
  }thead th{
    background: #404040;
    border: none;
    font-family: ${FONTS.GOTHAM_MEDIUM} !important;
    font-size: ${FONTS.SMALL_SIZE};
  }
  @media (max-width: 575.98px) {
    width:800px;
  thead, tbody tr{
    display:table;
    width:100%;
    table-layout:fixed;
  }
  td {
    padding-left: 1%;
  }
  th {
      padding-left: 1% ;
    }
  }
  @media (max-width: 767.98px) {
    width:800px;
  td {
    padding-left: 1%;
  }
  th {
      padding-left: 1% ;
  }
  }
  @media (max-width: 991.98px) {
    width:800px;
  td {
    padding-left: 1%;
  }
  th {
    padding-left: 1% ;
  }
  }
`
const BodyTable = styled.tbody`
  @media (max-width: 575.98px) {
    max-height: calc(100vh - 300px);
  }
  @media (max-width: 767.98px) {
    max-height: calc(100vh - 300px);
  }
  width: 100% ;
  display: block ;
  max-height: calc(100vh - 370px);
  overflow-y:scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`
const TableDiv = styled.div`
  padding-bottom: 30px;
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  @media (max-width: 575.98px) {
    padding-right: 0px;
    padding-left: 0px;
    font-size: 12px;
    width:100vw;
    overflow:scroll;
  }
  @media (max-width: 767.98px) {
    padding-right: 0px;
    padding-left: 0px;
    font-size: 12px;
    width:100vw;
    overflow:scroll;
  }
`
const Header = styled.thead`
  background: black;
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
`
const NumberField = styled(NumberFormat)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  text-align:right;
  width : 80% ;
  margin-left: 10% ;
  margin-right: 10% ;
  border-radius: 5px;
  border: 1px solid #CCCCCC;
  background-color: ${props => {
  const status = props.disabled
  if (status === !get(this.props, 'edit_vendor')) {
    return '#E8ECEF'
  }
  return '#FFFFFF'
  }};
`
const InputField = styled(Input)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  width : 100% ;
  height : 100% ;
`
const Trash = styled.div`
  background-image: ${props => {
  const edited = props.edit
  if (edited) {
    return `url(${TrashHover})`
  }
  return `url(${TrashDefault})`
}};
  background-repeat: no-repeat;
  align-self: center;
  border:0;
  width: 20px ;
  height: 20px ;
  margin: auto ;
  cursor: ${props => { return props.edit ? 'pointer' : 'default' }};
`



// WEBPACK FOOTER //
// ./src/components/project-information/table/table-vendor-cost/index.js